import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { Timings } from '@picsart/design-system/foundation/timings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      width: '100%',
      maxWidth: 636,
      padding: [Spacings.s64, Spacings.s0],
      margin: 'auto',

      [mediaQuery(1365)]: {
        padding: [Spacings.s40, Spacings.s0, 180],
      },

      [mediaQuery(1023)]: {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        maxWidth: 456,
      },
    },

    accordion: {
      '&&': {
        padding: Spacings.s0,

        '& > div': {
          paddingBottom: Spacings.s16,

          '&:hover': {
            backgroundColor: BackgroundColors.base,
          },

          '&:after': {
            right: Spacings.s16,
          },
        },
      },
    },

    title: {
      padding: [Spacings.s32, Spacings.s0, Spacings.s56],
      margin: [Spacings.s0, 'auto'],
      textAlign: 'center',
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s30,
      lineHeight: LineHeights.l36,
      color: TextColors.base,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: Spacings.s24,
        textAlign: 'left',
      },
    },

    accordionHeader: {
      '&&': {
        padding: [Spacings.s40, Spacings.s32, Spacings.s16, Spacings.s40],
        fontWeight: FontWeights.semibold,
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
        backgroundColor: 'transparent',
        border: 'none',
        transition: `background-color ${Timings.default} ease-in-out`,
      },
    },
    accordionContent: {
      '&&': {
        padding: [Spacings.s0, Spacings.s56, Spacings.s0, Spacings.s40],
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s16,
        lineHeight: LineHeights.l24,
        color: TextColors.base,
      },
    },

    question: {
      fontSize: Spacings.s16,
      lineHeight: LineHeights.l24,
      fontWeight: FontWeights.semibold,
    },
    // SKELETON
    rootFallback: {
      margin: [Spacings.s32, 'auto', Spacings.s56],
      maxWidth: 638,
    },
    titleFallback: {
      margin: [Spacings.s32, '10%', Spacings.s56],
      height: 32,

      '&.skeleton': {
        width: 'auto',
        maxWidth: '100%',
      },
    },

    itemFallback: {
      margin: [Spacings.s2, Spacings.s0],
      width: '100%',
      height: 90,
    },
    openedItemFallback: {
      height: 150,
    },
  }),
  {
    name: 'faq',
  },
);

export default useStyles;
